<phms-workflow-library-selector title="Lookup choices" searchLabel="Search lookup sources" allCategoryLabel="Lookup sources"
  [description]="description" [open]="internalOpen" [active]="active" [disabled]="disabled || retryDisabled" [context]="liveContext"
  [entries]="entries" [loading]="loading" loadingMessage="Reading current lookup sources…" [error]="error" [retryDisabled]="retryDisabled"
  emptyMessage="No lookup sources match this workflow context." [remoteSearch]="true" [entryDetailsTemplate]="sourceDetails"
  [statusTemplate]="savedSourceStatus"
  [footerMessage]="pageMessage" [footerActions]="footerActions" (searchRequested)="search($event)" (retryRequested)="retry()"
  (footerActionRequested)="page($event)" (chooseRequested)="choose($event)" (ownerActionRequested)="reviewDependency($event)"
  (opened)="libraryOpened()" (closed)="libraryClosed($event)" />
<ng-template #sourceDetails let-entry>
  <ng-container *ngIf="source(entry.id) as item">
    <ng-container [ngTemplateOutlet]="choiceDetails" [ngTemplateOutletContext]="{ $implicit: item }" />
  </ng-container>
</ng-template>
<ng-template #savedSourceStatus>
  <section *ngIf="savedBinding" aria-label="Saved lookup source" class="saved-lookup-source">
    <p>Saved source: {{ savedBinding.configurationCode }} / {{ savedBinding.domainCode }}. The binding stays unchanged until you explicitly choose a source.</p>
    <p *ngIf="savedSourceLoading" role="status">Checking the saved lookup source…</p>
    <p *ngIf="savedSourceError" role="status">{{ savedSourceError }}</p>
    <ng-container *ngIf="savedSource as item" [ngTemplateOutlet]="choiceDetails" [ngTemplateOutletContext]="{ $implicit: item }" />
  </section>
</ng-template>
<ng-template #choiceDetails let-item>
    <details *ngIf="item.choices.length" class="lookup-source-choices">
      <summary>View current choices</summary>
      <p>Codes are stored in answers; labels describe them. Retired choices cannot be newly selected.</p>
      <ul tabindex="0" [attr.aria-label]="'Current choices for ' + item.label"><li *ngFor="let choice of item.choices"><span>{{ choice.label }}</span>&nbsp;·&nbsp;<code>{{ choice.value }}</code><span *ngIf="!choice.isEnabled"> · Unavailable for new answers</span></li></ul>
    </details>
</ng-template>
